import _ from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { getAllReportApi, getReportDetailsApi } from './reportApi';

// ----------------------------------------------------------------------

const initialState = {
  reportList: [],
  isReportListLoading: false,
  selectedReport: {},
  isNoteLoading: false
};

const slice = createSlice({
  name: 'report',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllReportApi.pending]: (state) => {
      state.isReportListLoading = true;
    },
    [getAllReportApi.fulfilled]: (state, action) => {
      state.isReportListLoading = false;
      state.reportList = action.payload;
    },
    [getAllReportApi.rejected]: (state) => {
      state.isReportListLoading = false;
    },
    [getReportDetailsApi.pending]: (state, action) => {
      state.isNoteLoading = true;
      state.selectedReport = {};
    },
    [getReportDetailsApi.fulfilled]: (state, action) => {
      state.isNoteLoading = false;
      state.selectedReport = action.payload;
    }
  }
});
export const reportAction = slice.actions;

export default slice.reducer;
